import { Skeleton } from '@/components/ui/skeleton';
import { Card } from '@/components/ui/card';
import { useTranslation } from '@/hooks/useTranslation';

export function ToolSummaryCardsSkeleton() {
  const { t } = useTranslation();
  return (
    <section
      className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
      aria-live="polite"
      role="status"
      aria-label={t('toolView.detail.loadingSummary')}
    >
      {Array.from({ length: 7 }).map((_, index) => (
        <Card key={index} padding="sm" className="flex flex-col gap-3">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-3 w-40" />
        </Card>
      ))}
    </section>
  );
}
